(function () {
  'use strict';

  function initMasteryHubPage(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.nxedc-mastery-hub-page-wrap').forEach(function (wrap) {
      if (wrap.dataset.nxedcMasteryInit === '1') return;
      wrap.dataset.nxedcMasteryInit = '1';

      var grid = wrap.querySelector('[data-nxedc-mastery-hub-grid]');
      if (!grid) return;

      var perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 8;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-nxedc-mastery-hub-card]'));
      var actions = wrap.querySelector('[data-nxedc-mastery-hub-actions]');
      var countEl = wrap.querySelector('[data-nxedc-mastery-hub-count]');
      var loadBtn = wrap.querySelector('[data-nxedc-mastery-hub-load-more]');
      var visible = cards.filter(function (card) {
        return !card.classList.contains('is-hidden');
      }).length;

      function updateCount() {
        if (!countEl) return;
        var totalDisplay = parseInt(grid.getAttribute('data-total'), 10) || cards.length;
        countEl.textContent =
          "You've viewed " + visible + ' of ' + totalDisplay + ' result' + (totalDisplay === 1 ? '' : 's');
        var hidden = cards.filter(function (card) {
          return card.classList.contains('is-hidden');
        });
        if (hidden.length === 0 && actions) {
          actions.classList.add('is-complete');
        }
      }

      if (loadBtn) {
        loadBtn.addEventListener('click', function () {
          var hidden = cards.filter(function (card) {
            return card.classList.contains('is-hidden');
          });
          hidden.slice(0, perPage).forEach(function (card) {
            card.classList.remove('is-hidden');
          });
          visible = cards.filter(function (card) {
            return !card.classList.contains('is-hidden');
          }).length;
          updateCount();
        });
      }

      updateCount();
    });
  }

  (function initMasteryHubRoute() {
    var path = window.location.pathname.replace(/\/$/, '');

    function activateMasteryHubFallback() {
      if (path !== '/pages/mastery-hub') return;
      var main = document.getElementById('MainContent');
      if (!main || main.dataset.nxedcMasteryLoaded === '1') return;

      if (main.querySelector('.nxedc-mastery-hub-page-wrap:not([data-nxedc-mastery-hub-fallback])')) {
        main.dataset.nxedcMasteryLoaded = '1';
        initMasteryHubPage(main);
        return;
      }

      var fallback = main.querySelector('[data-nxedc-mastery-hub-fallback]');
      if (fallback) {
        fallback.classList.remove('nxedc-mastery-hub-fallback-hidden');
        main.dataset.nxedcMasteryLoaded = '1';
        initMasteryHubPage(main);
        return;
      }

      fetch('/404?sections=mastery_hub')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var html = data && data.mastery_hub;
          if (!html || !main) return;
          main.innerHTML = html;
          main.dataset.nxedcMasteryLoaded = '1';
          document.title = 'Mastery Hub – sparkedc';
          initMasteryHubPage(main);
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initMasteryHubPage(document);
        activateMasteryHubFallback();
      });
    } else {
      initMasteryHubPage(document);
      activateMasteryHubFallback();
    }

    document.addEventListener('shopify:section:load', function () {
      initMasteryHubPage(document);
    });
  })();

  (function initBrandOrStudioRoute() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/brand-or-studio') return;

    function activateBrandOrStudioFallback() {
      var main = document.getElementById('MainContent');
      if (!main || main.dataset.nxedcBrandOrStudioLoaded === '1') return;

      if (main.querySelector('.nxedc-brand-or-studio-wrap:not([data-nxedc-brand-or-studio-fallback])')) {
        main.dataset.nxedcBrandOrStudioLoaded = '1';
        return;
      }

      var fallback = main.querySelector('[data-nxedc-brand-or-studio-fallback]');
      if (fallback) {
        fallback.classList.remove('nxedc-brand-or-studio-fallback-hidden');
        main.dataset.nxedcBrandOrStudioLoaded = '1';
        return;
      }

      fetch('/404?sections=brand_or_studio,brand_or_studio_trust')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!main) return;
          var html = (data && data.brand_or_studio ? data.brand_or_studio : '') +
            (data && data.brand_or_studio_trust ? data.brand_or_studio_trust : '');
          if (!html) return;
          main.innerHTML = html;
          main.dataset.nxedcBrandOrStudioLoaded = '1';
          document.title = 'Brand or Studio – sparkedc';
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', activateBrandOrStudioFallback);
    } else {
      activateBrandOrStudioFallback();
    }
  })();

  (function initMasteryGuideRoute() {
    var path = window.location.pathname.replace(/\/$/, '');
    var blogMatch = path.match(/^\/blogs\/mastery-hub\/([^/]+)$/);
    var pageMatch = path.match(/^\/pages\/([^/]+)$/);
    var guideHandle = blogMatch ? blogMatch[1] : (pageMatch ? pageMatch[1] : '');
    if (!guideHandle || guideHandle === 'mastery-hub') return;

    var guideMap = {
      'tita-pro-complete-instruction-manual': 'guide_tita_pro',
      'tapedrive-how-to-fix-it-if-the-rotor-doesnt-move': 'guide_tapedrive',
      'teaching-of-the-open-armor-and-locked-armor-modes-for-the-sun-god-ra': 'guide_sun_god_ra',
      'snake-mini-disassembly-and-installation-tutorial': 'guide_snake_mini',
      'the-wave-teaching-of-various-gameplay-modes-hidden-play-mechanics': 'guide_the_wave',
      'bar-skylines-installation-process': 'guide_bar_skylines',
      'mechanical-cracker-magnetic-cracker-disassembly-and-tactile-feedback-debugging': 'guide_mechanical_cracker',
      'artillery-full-process-of-disassembly-and-assembly-mode-replacement-plate-replacement': 'guide_artillery',
    };

    var sectionId = guideMap[guideHandle];
    if (!sectionId) return;

    document.documentElement.classList.add('nxedc-route-mastery-guide');
    document.documentElement.dataset.nxedcGuideHandle = guideHandle;

    function activateGuideFallback() {
      var main = document.getElementById('MainContent');
      if (!main || main.dataset.nxedcGuideLoaded === '1') return;

      if (main.querySelector('.nxedc-mastery-guide-wrap:not([data-nxedc-mastery-guide-fallback])')) {
        main.dataset.nxedcGuideLoaded = '1';
        return;
      }

      var fallback = main.querySelector(
        '[data-nxedc-mastery-guide-fallback][data-guide-handle="' + guideHandle + '"]'
      );

      if (fallback) {
        document.querySelectorAll('[data-nxedc-mastery-guide-fallback]').forEach(function (node) {
          node.classList.remove('is-active');
          node.classList.add('nxedc-mastery-guide-fallback-hidden');
        });
        fallback.classList.remove('nxedc-mastery-guide-fallback-hidden');
        fallback.classList.add('is-active');

        main.querySelectorAll('.shopify-section').forEach(function (section) {
          if (!section.contains(fallback)) {
            section.style.display = 'none';
          }
        });

        main.dataset.nxedcGuideLoaded = '1';
        var titleEl = fallback.querySelector('.nxedc-mastery-guide__title');
        if (titleEl) document.title = titleEl.textContent.trim() + ' – sparkedc';
        return;
      }

      fetch('/404?sections=' + sectionId)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var html = data && data[sectionId];
          if (!html || !main) return;
          main.innerHTML = html;
          main.dataset.nxedcGuideLoaded = '1';
          var titleNode = main.querySelector('.nxedc-mastery-guide__title');
          if (titleNode) document.title = titleNode.textContent.trim() + ' – sparkedc';
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', activateGuideFallback);
    } else {
      activateGuideFallback();
    }
  })();

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function idle(fn) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn, { timeout: 1800 });
    } else {
      window.setTimeout(fn, 16);
    }
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  var nxedcMarqueeWidth = 0;
  var nxedcStickyHeaderBound = false;
  var nxedcCarouselObserver = null;

  function scrollPageToTop() {
    if (window.__nxedcHomeScroll) {
      window.__nxedcHomeScroll.prepare();
      return;
    }

    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) {
      wrapper.scrollTop = 0;
      wrapper.scrollLeft = 0;
      wrapper.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }

    var root = document.scrollingElement || document.documentElement;
    if (root) {
      root.scrollTop = 0;
      root.scrollLeft = 0;
      root.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }

  function initHomeNavigation() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (_) {
        return;
      }

      if (url.origin !== window.location.origin) return;

      var path = url.pathname.replace(/\/$/, '') || '/';
      if (path !== '/') return;

      try {
        sessionStorage.setItem('nxedc-home-top', '1');
      } catch (_) {}

      var onHome = window.location.pathname.replace(/\/$/, '') === '' || window.location.pathname === '/';
      if (!onHome) return;

      event.preventDefault();
      scrollPageToTop();
      try {
        var state = typeof history.state === 'object' && history.state !== null ? history.state : {};
        history.replaceState(Object.assign({}, state, { scrollTop: 0 }), '', url.pathname + url.search + url.hash);
      } catch (_) {}
    });
  }

  ready(function () {
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      document.querySelectorAll('[data-nxedc-reveal], [data-nxedc-stagger]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      initFooterPageContent();
    }

    initDropdowns();
    initMobileNav();
    initSearchDrawer();
    initStickyHeader();
    initMarquees(true);
    initHeroSwipers();
    initCountrySelector();
    initHomeNavigation();

    idle(function () {
      initProductCarousels();
      initCategoriesDrag();
      initBlogCarousel();
      initFaqAccordion();
      initScrollReveal();
      initSmoothScroll();
      initFeaturedGallery();
      initCartQty();
      initFooterPageContent();
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target || document;
    initDropdowns(root);
    initFaqAccordion();
    initCategoriesDrag();
    initProductCarousels(root);
    initHeroSwipers(root);
    initBlogCarousel(root);
    initFeaturedGallery();
    initMarquees(true);
    initScrollReveal();
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      root.querySelectorAll('[data-nxedc-reveal], [data-nxedc-stagger]').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  });

  window.addEventListener('resize', debounce(function () {
    initMarquees(true);
  }, 180), { passive: true });

  function initFooterPageContent() {
    document.querySelectorAll('[data-nxedc-use-footer-content]').forEach(function (wrapper) {
      var handle = wrapper.getAttribute('data-nxedc-page-handle');
      if (!handle) return;

      var store = document.getElementById('nxedc-page-store-' + handle);
      var root = wrapper.querySelector('[data-nxedc-info-page-root="' + handle + '"]');
      if (!store || !root || !store.innerHTML.trim()) return;

      root.innerHTML = store.innerHTML;
    });
  }

  var NXEDC_LOCALE_COUNTRY = {
    en: 'US',
    ja: 'JP',
    es: 'ES',
    fr: 'FR',
    de: 'DE',
    ko: 'KR',
    it: 'IT',
    'pt-PT': 'PT',
    ms: 'MY',
    ru: 'RU',
    'zh-TW': 'TW',
    'zh-CN': 'US',
    sv: 'SE',
    nl: 'NL',
    tr: 'TR',
    fi: 'FI'
  };

  var NXEDC_COUNTRY_LOCALE = {
    US: 'en',
    GB: 'en',
    CA: 'en',
    AU: 'en',
    JP: 'ja',
    ES: 'es',
    FR: 'fr',
    DE: 'de',
    KR: 'ko',
    IT: 'it',
    PT: 'pt-PT',
    MY: 'ms',
    RU: 'ru',
    TW: 'zh-TW',
    SE: 'sv',
    NL: 'nl',
    TR: 'tr',
    FI: 'fi'
  };

  function submitNxedcLocalization(form) {
    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    var returnInput = form.querySelector('input[name="return_to"]');
    if (returnInput) returnInput.value = returnTo;
    form.submit();
  }

  function initCountrySelector() {
    if (document.documentElement.dataset.nxedcCountrySelectorBound === 'true') return;
    document.documentElement.dataset.nxedcCountrySelectorBound = 'true';

    var wraps = document.querySelectorAll('[data-nxedc-country-selector]');
    if (!wraps.length) return;

    var backdrop = document.getElementById('NxedcLocBackdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = 'NxedcLocBackdrop';
      backdrop.className = 'nxedc-loc-disclosure__backdrop';
      backdrop.hidden = true;
      document.body.appendChild(backdrop);
    }

    function closeWrap(wrap) {
      var toggle = wrap.querySelector('[data-nxedc-country-toggle]');
      var panelId = toggle && toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : wrap.querySelector('[data-nxedc-country-panel]');
      if (panel) {
        panel.hidden = true;
        panel.classList.remove('is-visible');
        panel.style.top = '';
        panel.style.left = '';
        panel.style.minWidth = '';
        panel.style.visibility = 'hidden';
        panel.style.pointerEvents = 'none';
        panel.style.left = '-9999px';
      }
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      backdrop.hidden = true;
    }

    function positionPanel(wrap) {
      var toggle = wrap.querySelector('[data-nxedc-country-toggle]');
      var panelId = toggle && toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : wrap.querySelector('[data-nxedc-country-panel]');
      if (!toggle || !panel) return;

      var rect = toggle.getBoundingClientRect();
      var gap = 10;
      var panelWidth = Math.max(rect.width, 300);
      var left = Math.max(12, rect.left);
      var panelHeight = panel.offsetHeight || 420;
      var top = rect.bottom + gap;

      if (wrap.classList.contains('nxedc-loc-disclosure--footer')) {
        top = rect.top - gap - panelHeight;
      }

      if (top + panelHeight > window.innerHeight - 12) {
        top = Math.max(12, rect.top - gap - panelHeight);
      }

      if (left + panelWidth > window.innerWidth - 12) {
        left = Math.max(12, window.innerWidth - panelWidth - 12);
      }

      panel.style.left = left + 'px';
      panel.style.top = top + 'px';
      panel.style.minWidth = panelWidth + 'px';
    }

    function closeAll(except) {
      wraps.forEach(function (wrap) {
        if (except && wrap === except) return;
        closeWrap(wrap);
      });
    }

    closeAll();

    backdrop.addEventListener('click', function () {
      closeAll();
    });

    document.addEventListener('click', function (e) {
      var pickBtn = e.target.closest('[data-nxedc-loc-pick]');
      if (pickBtn) {
        var panel = pickBtn.closest('[data-nxedc-country-panel]');
        if (!panel || !panel.id) return;

        var toggle = document.querySelector('[data-nxedc-country-toggle][aria-controls="' + panel.id + '"]');
        var wrap = toggle && toggle.closest('[data-nxedc-country-selector]');
        var form = wrap && wrap.querySelector('.nxedc-loc-disclosure__form');
        if (!form) return;

        e.preventDefault();
        e.stopPropagation();

        var countryInput = form.querySelector('[data-nxedc-loc-country]');
        var languageInput = form.querySelector('[data-nxedc-loc-language]');
        if (!countryInput || !languageInput) return;

        var pick = pickBtn.getAttribute('data-nxedc-loc-pick');
        var value = pickBtn.getAttribute('data-value') || '';

        if (pick === 'language') {
          languageInput.value = value;
          if (NXEDC_LOCALE_COUNTRY[value]) {
            countryInput.value = NXEDC_LOCALE_COUNTRY[value];
          }
        } else if (pick === 'country') {
          countryInput.value = value;
          if (NXEDC_COUNTRY_LOCALE[value]) {
            languageInput.value = NXEDC_COUNTRY_LOCALE[value];
          }
        }

        submitNxedcLocalization(form);
        return;
      }

      if (e.target.closest('[data-nxedc-country-toggle]')) return;
      if (e.target.closest('[data-nxedc-country-panel]')) return;
      closeAll();
    });

    wraps.forEach(function (wrap, index) {
      if (wrap.dataset.nxedcCountryBound === '1') return;
      wrap.dataset.nxedcCountryBound = '1';

      var toggle = wrap.querySelector('[data-nxedc-country-toggle]');
      var panel = wrap.querySelector('[data-nxedc-country-panel]');
      if (!toggle || !panel) return;

      if (!panel.dataset.portaled) {
        panel.dataset.portaled = 'true';
        panel.dataset.nxedcLocWrap = String(index);
        document.body.appendChild(panel);
      }

      panel.hidden = true;
      panel.classList.remove('is-visible');
      panel.style.visibility = 'hidden';
      panel.style.pointerEvents = 'none';
      panel.style.left = '-9999px';

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (wrap.classList.contains('is-open')) {
          closeWrap(wrap);
          return;
        }

        closeAll(wrap);
        panel.hidden = false;
        panel.classList.add('is-visible');
        panel.style.visibility = 'hidden';
        panel.style.pointerEvents = 'none';
        backdrop.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        wrap.classList.add('is-open');

        requestAnimationFrame(function () {
          positionPanel(wrap);
          panel.style.visibility = 'visible';
          panel.style.pointerEvents = 'auto';
          requestAnimationFrame(function () {
            positionPanel(wrap);
          });
        });
      });
    });

    window.addEventListener('resize', debounce(function () {
      wraps.forEach(function (wrap) {
        if (wrap.classList.contains('is-open')) positionPanel(wrap);
      });
    }, 120));

    window.addEventListener('scroll', debounce(function () {
      wraps.forEach(function (wrap) {
        if (wrap.classList.contains('is-open')) positionPanel(wrap);
      });
    }, 80), true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  function initFooterLocalization() {
    initCountrySelector();
  }

  function initLocalization() {
    initCountrySelector();
  }

  function initHeroSwipers(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-nxedc-hero-swiper]').forEach(function (el) {
      if (el.dataset.nxedcSwiperReady === '1' && el._nxedcSwiper) return;
      if (el._nxedcSwiper) {
        el._nxedcSwiper.destroy(true, true);
        el._nxedcSwiper = null;
      }
      el.dataset.nxedcSwiperReady = '1';
      var section = el.closest('.nxedc-hero');
      var editorial = section && section.classList.contains('nxedc-hero--editorial');
      var indexEl = section && section.querySelector('[data-nxedc-hero-index]');
      var eyebrowEl = section && section.querySelector('[data-nxedc-hero-eyebrow]');
      var headingEl = section && section.querySelector('[data-nxedc-hero-heading]');
      var textEl = section && section.querySelector('[data-nxedc-hero-text]');
      var actionsEl = section && section.querySelector('[data-nxedc-hero-actions]');
      var autoplayDelay = 6000;

      function padNum(n) {
        return (n < 10 ? '0' : '') + n;
      }

      function syncEditorialCopy(slideEl) {
        if (!slideEl || !editorial) return;
        var idx = slideEl.getAttribute('data-slide-index') || '1';
        if (indexEl) indexEl.textContent = padNum(parseInt(idx, 10));
        if (eyebrowEl) eyebrowEl.textContent = slideEl.getAttribute('data-eyebrow') || '';
        if (headingEl) headingEl.textContent = slideEl.getAttribute('data-heading') || '';
        if (textEl) textEl.textContent = slideEl.getAttribute('data-text') || '';
        if (actionsEl) {
          var html = '';
          var label = slideEl.getAttribute('data-btn-label');
          var link = slideEl.getAttribute('data-btn-link');
          var label2 = slideEl.getAttribute('data-btn2-label');
          var link2 = slideEl.getAttribute('data-btn2-link');
          if (label) html += '<a class="nxedc-btn" href="' + link + '">' + label + '</a>';
          if (label2) html += '<a class="nxedc-btn nxedc-btn--outline" href="' + link2 + '">' + label2 + '</a>';
          actionsEl.innerHTML = html;
        }
        [indexEl, eyebrowEl, headingEl, textEl, actionsEl].forEach(function (node) {
          if (!node) return;
          node.style.animation = 'none';
          void node.offsetWidth;
          node.style.animation = '';
        });
      }

      var swiper = new Swiper(el, {
        loop: true,
        autoplay: { delay: autoplayDelay, disableOnInteraction: false },
        effect: 'fade',
        fadeEffect: { crossFade: true },
        navigation: {
          nextEl: el.querySelector('.nxedc-swiper-next'),
          prevEl: el.querySelector('.nxedc-swiper-prev')
        },
        pagination: {
          el: el.querySelector('.nxedc-swiper-pagination'),
          clickable: true
        },
        on: {
          init: function () {
            syncEditorialCopy(el.querySelector('.swiper-slide-active'));
          },
          slideChangeTransitionStart: function () {
            syncEditorialCopy(el.querySelector('.swiper-slide-active'));
          }
        }
      });
      el._nxedcSwiper = swiper;
    });
  }

  function equalizeImpactMobileSlides(swiper) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return;
    if (window.innerWidth >= 990) {
      swiper.slides.forEach(function (slide) {
        slide.style.height = '';
      });
      return;
    }
    var maxH = 0;
    swiper.slides.forEach(function (slide) {
      slide.style.height = 'auto';
    });
    swiper.slides.forEach(function (slide) {
      maxH = Math.max(maxH, slide.offsetHeight);
    });
    if (maxH > 0) {
      swiper.slides.forEach(function (slide) {
        slide.style.height = maxH + 'px';
      });
    }
  }

  function bindImpactMobileSlideHeights(el, swiper) {
    if (el.dataset.nxedcImpactHeightsBound === '1') return;
    el.dataset.nxedcImpactHeightsBound = '1';

    var equalize = debounce(function () {
      equalizeImpactMobileSlides(swiper);
    }, 120);

    equalizeImpactMobileSlides(swiper);
    swiper.on('resize', equalize);
    swiper.on('imagesReady', equalize);
    window.addEventListener('resize', equalize, { passive: true });
    el.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', equalize);
    });
  }

  function mountProductCarousel(el) {
    if (!el || el.dataset.nxedcSwiperReady === '1') return;
    if (typeof Swiper === 'undefined') return;
    el.dataset.nxedcSwiperReady = '1';
      var isGrid4 = el.hasAttribute('data-nxedc-grid-4-swiper');
      var isImpact = el.hasAttribute('data-nxedc-impact-swiper');
      var columns = parseInt(el.dataset.columns || '4', 10);
      var config;

      if (isGrid4) {
        config = {
          slidesPerView: 2,
          spaceBetween: 12,
          watchOverflow: true,
          navigation: {
            nextEl: el.querySelector('.nxedc-swiper-next'),
            prevEl: el.querySelector('.nxedc-swiper-prev')
          },
          breakpoints: {
            750: { slidesPerView: 2, spaceBetween: 16 },
            990: { slidesPerView: 4, spaceBetween: 20 },
            1200: { slidesPerView: 4, spaceBetween: 24 }
          }
        };
      } else {
        config = {
          slidesPerView: isImpact ? 2 : 2.2,
          spaceBetween: isImpact ? 12 : 12,
          navigation: {
            nextEl: el.querySelector('.nxedc-swiper-next'),
            prevEl: el.querySelector('.nxedc-swiper-prev')
          },
          breakpoints: isImpact ? {
            750: { slidesPerView: 2, spaceBetween: 14 },
            990: { slidesPerView: Math.min(columns, 3.5), spaceBetween: 24 },
            1200: { slidesPerView: Math.min(columns + 0.2, 4.2), spaceBetween: 28 },
            1440: { slidesPerView: columns, spaceBetween: 28 }
          } : {
            750: { slidesPerView: 3.2, spaceBetween: 16 },
            990: { slidesPerView: 4, spaceBetween: 16 },
            1200: { slidesPerView: columns, spaceBetween: 16 }
          }
        };
      }

      var swiper = new Swiper(el, config);
      if (isImpact) bindImpactMobileSlideHeights(el, swiper);
      if (isGrid4) bindImpactMobileSlideHeights(el, swiper);
  }

  function initProductCarousels(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll('[data-nxedc-products-swiper]:not([data-nxedc-swiper-ready])');
    if (!elements.length) return;

    var viewportBottom = window.innerHeight + 240;

    function queueCarousel(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top <= viewportBottom) {
        mountProductCarousel(el);
        return;
      }
      if (!('IntersectionObserver' in window)) {
        mountProductCarousel(el);
        return;
      }
      if (!nxedcCarouselObserver) {
        nxedcCarouselObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            mountProductCarousel(entry.target);
            nxedcCarouselObserver.unobserve(entry.target);
          });
        }, { rootMargin: '240px 0px' });
      }
      nxedcCarouselObserver.observe(el);
    }

    elements.forEach(queueCarousel);
  }

  function initCategoriesDrag() {
    document.querySelectorAll('[data-nxedc-categories-drag]').forEach(function (track) {
      if (track._nxedcDragBound) return;
      track._nxedcDragBound = true;

      var isPointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startY = 0;
      var scrollStart = 0;
      var dragThreshold = 8;
      var touchMode = false;
      var touchDidScroll = false;

      track.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('draggable', 'false');
      });

      function onMove(clientX, clientY, preventDefaultFn) {
        if (!isPointerDown) return;
        var dx = clientX - startX;
        var dy = clientY - startY;

        if (!isDragging) {
          if (Math.abs(dx) < dragThreshold && Math.abs(dy) < dragThreshold) return;
          if (touchMode && Math.abs(dy) > Math.abs(dx)) {
            isPointerDown = false;
            return;
          }
          if (Math.abs(dx) < dragThreshold) return;
          isDragging = true;
          track.classList.add('is-dragging');
        }

        if (Math.abs(dx) > 10 || Math.abs(dy) > 10) touchDidScroll = true;
        if (preventDefaultFn) preventDefaultFn();
        track.scrollLeft = scrollStart - dx;
      }

      function endDrag() {
        if (!isPointerDown && !isDragging) return;
        isPointerDown = false;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', endDrag);

        if (isDragging) {
          track._nxedcSuppressClick = true;
          window.setTimeout(function () {
            track._nxedcSuppressClick = false;
          }, 0);
        }

        isDragging = false;
        touchMode = false;
        track.classList.remove('is-dragging');
      }

      function onMouseMove(e) {
        onMove(e.pageX, e.pageY, function () { e.preventDefault(); });
      }

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isPointerDown = true;
        isDragging = false;
        touchMode = false;
        startX = e.pageX;
        startY = e.pageY;
        scrollStart = track.scrollLeft;
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', endDrag);
      });

      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        isPointerDown = true;
        isDragging = false;
        touchMode = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        scrollStart = track.scrollLeft;
        touchDidScroll = false;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!isPointerDown) return;
        onMove(e.touches[0].clientX, e.touches[0].clientY, function () {
          if (isDragging) e.preventDefault();
        });
      }, { passive: false });

      track.addEventListener('touchend', endDrag, { passive: true });
      track.addEventListener('touchcancel', endDrag, { passive: true });

      track.addEventListener('click', function (e) {
        if (track._nxedcSuppressClick || touchDidScroll) {
          e.preventDefault();
          e.stopImmediatePropagation();
          touchDidScroll = false;
        }
      }, true);

      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });
  }

  function initBlogCarousel(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-nxedc-blog-swiper]').forEach(function (el) {
      if (el.dataset.nxedcSwiperReady === '1') return;
      el.dataset.nxedcSwiperReady = '1';
      new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        navigation: {
          nextEl: el.querySelector('.nxedc-swiper-next'),
          prevEl: el.querySelector('.nxedc-swiper-prev')
        },
        breakpoints: {
          750: { slidesPerView: 2.2 },
          990: { slidesPerView: 3.2 },
          1200: { slidesPerView: 4 }
        }
      });
    });
  }

  function initMarquees(force) {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    if (!force && nxedcMarqueeWidth && Math.abs(viewportWidth - nxedcMarqueeWidth) < 48) return;
    nxedcMarqueeWidth = viewportWidth;

    document.querySelectorAll('[data-nxedc-marquee]').forEach(function (track) {
      var original = track.getAttribute('data-nxedc-marquee-original');
      if (!original) {
        original = track.innerHTML.trim();
        if (!original) return;
        track.setAttribute('data-nxedc-marquee-original', original);
      }

      track.innerHTML = original;

      var minWidth = Math.max(viewportWidth * 2, 1);
      var guard = 0;
      while (track.scrollWidth < minWidth && guard < 24) {
        track.innerHTML += original;
        guard += 1;
      }

      track.dataset.nxedcMarqueeReady = '1';
    });
  }

  var nxedcDropdownsBound = false;

  function isDesktopNav() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll('[data-nxedc-dropdown].is-open').forEach(function (el) {
      if (el !== except) el.classList.remove('is-open');
    });
  }

  function bindDropdownItems(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = scope === document ? scope.querySelectorAll('[data-nxedc-dropdown]') : scope.querySelectorAll('[data-nxedc-dropdown]');

    items.forEach(function (item) {
      if (item.dataset.nxedcDropdownBound === '1') return;
      item.dataset.nxedcDropdownBound = '1';

      item.addEventListener('mouseenter', function () {
        if (!isDesktopNav()) return;
        closeAllDropdowns(item);
        item.classList.add('is-open');
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktopNav()) return;
        item.classList.remove('is-open');
      });
    });
  }

  function initDropdowns(root) {
    bindDropdownItems(root || document);

    if (nxedcDropdownsBound) return;
    nxedcDropdownsBound = true;

    document.addEventListener('click', function (e) {
      var dropdown = e.target.closest('[data-nxedc-dropdown]');
      var toggle = e.target.closest('[data-nxedc-dropdown-toggle]');

      if (toggle && dropdown && isDesktopNav()) {
        e.preventDefault();
        e.stopPropagation();
        var open = dropdown.classList.contains('is-open');
        closeAllDropdowns(dropdown);
        dropdown.classList.toggle('is-open', !open);
        return;
      }

      if (!dropdown) closeAllDropdowns();
    });
  }

  function initMobileNav() {
    if (document.documentElement.dataset.nxedcMobileNavBound === 'true') return;
    document.documentElement.dataset.nxedcMobileNavBound = 'true';

    function getDrawer() {
      var drawers = document.querySelectorAll('[data-nxedc-mobile-drawer]');
      if (!drawers.length) return null;
      if (drawers.length > 1) {
        for (var i = 1; i < drawers.length; i++) {
          drawers[i].remove();
        }
      }
      var drawer = drawers[0];
      if (!drawer.dataset.nxedcPortaled) {
        drawer.dataset.nxedcPortaled = 'true';
        document.body.appendChild(drawer);
      }
      return drawer;
    }

    function open() {
      var drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.add('is-open');
      document.body.classList.add('nxedc-nav-open');
      document.querySelectorAll('.nxedc-mobile-nav__menu').forEach(function (btn) {
        btn.classList.add('is-active');
      });
    }

    function close() {
      var drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('nxedc-nav-open');
      document.querySelectorAll('.nxedc-mobile-nav__menu').forEach(function (btn) {
        btn.classList.remove('is-active');
      });
    }

    getDrawer();
    close();

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nxedc-mobile-open]')) {
        e.preventDefault();
        var drawer = getDrawer();
        if (!drawer) return;
        if (drawer.classList.contains('is-open')) close();
        else open();
        return;
      }

      if (e.target.closest('[data-nxedc-mobile-close]')) {
        e.preventDefault();
        close();
        return;
      }

      var drawer = getDrawer();
      if (drawer && e.target === drawer) close();
    });

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-nxedc-submenu-toggle]');
      if (!toggle) return;
      var drawer = getDrawer();
      if (!drawer || !drawer.contains(toggle)) return;
      toggle.closest('[data-nxedc-submenu]').classList.toggle('is-open');
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-nxedc-mobile-drawer] a[href]');
      if (link) close();
    });
  }

  function initSearchDrawer() {
    var drawer = document.querySelector('[data-nxedc-search-drawer]');
    var openBtns = document.querySelectorAll('[data-nxedc-search-open]');
    var closeBtn = document.querySelector('[data-nxedc-search-close]');
    if (!drawer) return;
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        drawer.classList.add('is-open');
        var input = drawer.querySelector('input[type="search"]');
        if (input) input.focus();
      });
    });
    document.querySelectorAll('[data-nxedc-search-mobile]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (window.innerWidth < 990) {
          e.preventDefault();
          drawer.classList.add('is-open');
          var input = drawer.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    });
    function close() { drawer.classList.remove('is-open'); }
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
  }

  function initStickyHeader() {
    if (nxedcStickyHeaderBound) return;
    var chrome = document.querySelector('[data-nxedc-sticky-chrome]');
    var header = chrome
      ? chrome.querySelector('[data-nxedc-sticky-header]')
      : document.querySelector('[data-nxedc-sticky-header]');
    if (!chrome && !header) return;
    nxedcStickyHeaderBound = true;

    function syncChromeHeight() {
      var heightTarget = chrome || header;
      if (!heightTarget) return;
      document.documentElement.style.setProperty('--nxedc-chrome-height', heightTarget.offsetHeight + 'px');
    }

    syncChromeHeight();
    window.addEventListener('resize', debounce(syncChromeHeight, 120), { passive: true });

    var scrollTicking = false;
    window.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        scrollTicking = false;
        var y = window.scrollY;
        var scrollTarget = chrome || header;
        if (!scrollTarget) return;
        scrollTarget.classList.toggle('is-scrolled', y > 40);
      });
    }, { passive: true });
  }

  function initFaqAccordion() {
    document.querySelectorAll('[data-nxedc-faq]:not([data-nxedc-faq-bound])').forEach(function (root) {
      root.setAttribute('data-nxedc-faq-bound', 'true');
      root.addEventListener('toggle', function (e) {
        var item = e.target;
        if (!item.matches('[data-nxedc-faq-item]') || !item.open) return;
        root.querySelectorAll('[data-nxedc-faq-item][open]').forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      }, true);
    });
  }

  function initScrollReveal() {
    var revealSelector = '[data-nxedc-reveal], [data-nxedc-stagger]';

    function markVisible(el) {
      el.classList.add('is-visible');
    }

    function revealIfInViewport(el) {
      if (el.classList.contains('is-visible')) return true;
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom <= 0 || rect.top >= vh) return false;
      markVisible(el);
      return true;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll(revealSelector).forEach(markVisible);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        markVisible(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -2% 0px', threshold: 0.01 });

    document.querySelectorAll('[data-nxedc-reveal]').forEach(function (el) {
      if (el.dataset.nxedcRevealBound === '1') return;
      el.dataset.nxedcRevealBound = '1';
      if (!revealIfInViewport(el)) observer.observe(el);
    });

    document.querySelectorAll('[data-nxedc-stagger]').forEach(function (el) {
      if (el.dataset.nxedcRevealBound === '1') return;
      el.dataset.nxedcRevealBound = '1';
      if (!revealIfInViewport(el)) observer.observe(el);
    });
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      var id = link.getAttribute('href');
      if (!id || id === '#') return;
      link.addEventListener('click', function (e) {
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initFeaturedGallery() {
    document.querySelectorAll('[data-nxedc-featured-gallery]').forEach(function (gallery) {
      if (gallery.dataset.nxedcGalleryReady === '1') return;
      gallery.dataset.nxedcGalleryReady = '1';

      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-nxedc-slide]'));
      var thumbs = gallery.querySelectorAll('[data-nxedc-thumb]');
      var prevBtn = gallery.querySelector('[data-nxedc-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-nxedc-gallery-next]');
      if (!slides.length) return;

      function pauseSlideMedia(slide) {
        if (!slide) return;
        slide.querySelectorAll('video').forEach(function (video) {
          try { video.pause(); } catch (e) {}
        });
        slide.querySelectorAll('.nxedc-pdp__video-wrap').forEach(function (wrap) {
          wrap.classList.remove('is-playing');
        });
      }

      function syncVideoPlayButton(wrap) {
        var video = wrap.querySelector('video');
        var playBtn = wrap.querySelector('[data-nxedc-video-play]');
        if (!video || !playBtn) return;
        var playing = !video.paused && !video.ended;
        wrap.classList.toggle('is-playing', playing);
        playBtn.hidden = playing;
      }

      function bindVideoWrap(wrap) {
        if (wrap.dataset.nxedcVideoBound === '1') return;
        wrap.dataset.nxedcVideoBound = '1';
        var video = wrap.querySelector('video');
        var playBtn = wrap.querySelector('[data-nxedc-video-play]');
        if (!video || !playBtn) return;

        playBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          video.play().catch(function () {});
        });

        ['play', 'pause', 'ended'].forEach(function (eventName) {
          video.addEventListener(eventName, function () {
            syncVideoPlayButton(wrap);
          });
        });

        syncVideoPlayButton(wrap);
      }

      function activateSlideVideo(slide) {
        if (!slide) return;
        slide.querySelectorAll('.nxedc-pdp__video-wrap').forEach(bindVideoWrap);
      }

      function bindGallerySwipe() {
        if (!gallery.hasAttribute('data-nxedc-gallery-swipe')) return;
        var stage = gallery.querySelector('.nxedc-pdp__gallery-stage');
        if (!stage || stage.dataset.nxedcSwipeBound === '1') return;
        stage.dataset.nxedcSwipeBound = '1';

        var startX = 0;
        var startY = 0;
        var tracking = false;
        var threshold = 48;

        stage.addEventListener('touchstart', function (event) {
          if (event.touches.length !== 1) return;
          if (event.target.closest('video, iframe, button, .nxedc-pdp__gallery-nav')) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          tracking = true;
        }, { passive: true });

        stage.addEventListener('touchend', function (event) {
          if (!tracking) return;
          tracking = false;
          var touch = event.changedTouches[0];
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
          showRelative(dx < 0 ? 1 : -1);
        }, { passive: true });

        var pointerDown = false;
        stage.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'touch') return;
          if (event.target.closest('video, iframe, button, .nxedc-pdp__gallery-nav')) return;
          pointerDown = true;
          startX = event.clientX;
          startY = event.clientY;
          stage.classList.add('is-dragging');
        });

        stage.addEventListener('pointerup', function (event) {
          if (!pointerDown) return;
          pointerDown = false;
          stage.classList.remove('is-dragging');
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
          showRelative(dx < 0 ? 1 : -1);
        });

        stage.addEventListener('pointercancel', function () {
          pointerDown = false;
          stage.classList.remove('is-dragging');
        });
      }

      function slideOrder() {
        return slides.map(function (slide) {
          return slide.getAttribute('data-nxedc-slide');
        });
      }

      function currentSlideIndex() {
        var active = slides.find(function (slide) {
          return !slide.classList.contains('is-hidden');
        });
        return active ? active.getAttribute('data-nxedc-slide') : slides[0].getAttribute('data-nxedc-slide');
      }

      function scrollThumbIntoView(thumb) {
        if (!thumb) return;
        var thumbsRow = thumb.closest('.nxedc-pdp__thumbs');
        if (!thumbsRow) return;
        var isVertical = thumbsRow.classList.contains('nxedc-pdp__thumbs--vertical');
        if (isVertical) {
          try {
            thumb.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
          } catch (e) {
            thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
          return;
        }
        var thumbRect = thumb.getBoundingClientRect();
        var rowRect = thumbsRow.getBoundingClientRect();
        if (thumbRect.left >= rowRect.left - 2 && thumbRect.right <= rowRect.right + 2) return;
        try {
          thumb.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
        } catch (e) {
          thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      }

      function showSlide(index) {
        var target = String(index);
        slides.forEach(function (slide) {
          var show = slide.getAttribute('data-nxedc-slide') === target;
          if (!show) pauseSlideMedia(slide);
          slide.classList.toggle('is-hidden', !show);
        });
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-nxedc-thumb') === target);
          if (thumb.getAttribute('data-nxedc-thumb') === target) {
            scrollThumbIntoView(thumb);
          }
        });

        var counter = gallery.querySelector('[data-nxedc-gallery-counter]');
        if (counter) {
          var order = slideOrder();
          var position = order.indexOf(target);
          if (position === -1) position = 0;
          counter.textContent = (position + 1) + ' / ' + order.length;
        }

        var activeSlide = slides.find(function (slide) {
          return slide.getAttribute('data-nxedc-slide') === target;
        });
        if (activeSlide && activeSlide.getAttribute('data-media-type') === 'video') {
          activateSlideVideo(activeSlide);
        }
      }

      function showRelative(step) {
        var order = slideOrder();
        var current = currentSlideIndex();
        var position = order.indexOf(current);
        if (position === -1) position = 0;
        var next = order[(position + step + order.length) % order.length];
        showSlide(next);
      }

      gallery._nxedcShowSlide = function (index) {
        showSlide(index);
      };

      gallery.querySelectorAll('.nxedc-pdp__video-wrap').forEach(bindVideoWrap);

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          showRelative(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          showRelative(1);
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showSlide(thumb.getAttribute('data-nxedc-thumb'));
        });
      });

      bindGallerySwipe();
      showSlide(currentSlideIndex());
    });
  }

  function initCartQty() {
    document.querySelectorAll('.nxedc-cart-item__qty').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      var minus = wrap.querySelector('[data-nxedc-qty-minus]');
      var plus = wrap.querySelector('[data-nxedc-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        input.value = Math.max(0, parseInt(input.value, 10) - 1 || 0);
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
      });
    });
  }

  function initSparkAmbience() {
    if (!document.body.classList.contains('sparkedc-atelier')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.querySelector('.sp-orb')) return;
    ['sp-orb--1', 'sp-orb--2'].forEach(function (cls) {
      var orb = document.createElement('div');
      orb.className = 'sp-orb ' + cls;
      orb.setAttribute('aria-hidden', 'true');
      document.body.appendChild(orb);
    });
  }

})();
